import { useQuery } from 'react-query'
import { InfowindowRepository } from 'repository/infowindow'

export const useFetchInfowindow = (id: number, layerId: number, options?: any) => {
  let idarm = id + layerId
  let res = useQuery(!!idarm && ['infowindow', { idarm }], () => InfowindowRepository.fetch(id, layerId), {
    ...options,
    retry: false,
  })

  return res
}
